module.exports = __webpack_public_path__ + "img/outofstock.f5162d06.png";